import axiosInstance from './axios-instance';
import {
  GetListNotificationResponseDTO,
  GetUserNotificationPlatformResponseDTO,
  PostUpdateUserNotificationResponseDTO
} from '@twygs/shared/notification-interface';

export const fetchListNotification = async (params) => {
  const result: GetListNotificationResponseDTO = await axiosInstance.get(
    `/api/v1/notifications/notifications/get-list`,
    {
      params
    }
  );
  return result.data;
};

export const fetchListSettings = async () => {
  const result: GetUserNotificationPlatformResponseDTO = await axiosInstance.get(
    `/api/v1/notifications/notifications/get-setting/NEWSLETTER`
  );
  return result.data;
};

export const updateSettings = async (params) => {
  const result: PostUpdateUserNotificationResponseDTO = await axiosInstance.post(
    `/api/v1/notifications/notifications/update-setting`,
    {
      typeId: params.typeId,
      option: params.option
    }
  );
  return result.data;
};

export const GET_DISMISS = `/api/v1/notifications/notifications/dismiss`;
export const GET_MARK_AS_READ = `/api/v1/notifications/notifications/mark-as-read`;
export const GET_MARK_AS_UNREAD = `/api/v1/notifications/notifications/mark-as-unread`;
export const GET_MARK_ALL_AS_READ = `/api/v1/notifications/notifications/mark-all-as-read`;
